// @flow
import React, { createContext, FunctionComponent, PropsWithChildren, useCallback, useMemo, useState } from 'react';

import Flag, { FlagGroup } from '@atlaskit/flag';
import { noop } from 'lodash';

export interface FlagContextType {
    pushFlag: (flag) => void;
    dismissFlag: () => void;
}

const initialState = {
    pushFlag: noop,
    dismissFlag: noop,
};

export const Context = createContext<FlagContextType>(initialState);

const Provider: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
    const [flags, setFlags] = useState([]);

    const dismissFlag = useCallback(() => setFlags((prev) => prev.slice(1)), []);

    const pushFlag = useCallback((flag) => setFlags((prev) => [...prev, flag]), []);

    const contextValue = useMemo<FlagContextType>(
        () => ({
            pushFlag,
            dismissFlag,
        }),
        [pushFlag, dismissFlag],
    );

    return (
        <Context.Provider value={contextValue}>
            {children}
            <FlagGroup onDismissed={dismissFlag}>
                {flags.map((flag) => (
                    <Flag key={flag.id} {...flag} />
                ))}
            </FlagGroup>
        </Context.Provider>
    );
};

export const withFlagContext = (Component) => {
    const WithFlagContext = (props) => {
        return (
            <Provider>
                <Component {...props} />
            </Provider>
        );
    };
    return WithFlagContext;
};

export default Provider;
